
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 5a7 7 0 11-7 7 7 7 0 017-7m0-2a9 9 0 109 9 9 9 0 00-9-9z"}}),_c('path',{attrs:{"d":"M15.7 9.74a1 1 0 00-1.41 0L11 13.07l-1.3-1.31a1 1 0 00-1.41 1.41l2 2a1 1 0 00.71.29 1 1 0 00.71-.29l4-4a1 1 0 00-.01-1.43z"}})])
          )
        }
      }
    